<template>
    <div class="live-detail-home">
        <column-skeleton style="position: absolute;z-index: 99999;width: 100vw;height: 100vh;background: #fff" v-if="loading"></column-skeleton>

        <div style="position: relative;top: 0;z-index: 9;background: #fff">
            <div class="ad" v-show="live.adverts_up && live.adverts_up.length > 0">
                <swiper ref="mySwiper" :options="swiperOption">
                    <swiper-slide class="ad_logo_slide" v-for="(item, index) in live.adverts_up" :key="index">
                        <img class="ad_logo" :src="item.logo" alt="" />
                    </swiper-slide>
                </swiper>
            </div>
            <div style="position: relative">
                <div id="mudu" class="mudu" :style="'background-image: url(' + live.cover_img + ');background-size:100% 100%;background-position:100% 100%;'">
                    <video :id="this.video_id" class="mudu video-js vjs-default-skin vjs-big-play-centered" controls preload="none" x5-playsinline="" webkit-playsinline="" playsinline="" :poster="this.live.cover_img" x-webkit-airplay="true"></video>
                    <div class="live-detail-view_count">
                        <img src="/static/img/icon_live_watch.svg" alt="" />
                        {{ this.live.view_count }}人观看
                    </div>
                </div>
                <van-count-down :time="time" @finish="finish" class="live-detail-count-down" v-if="time > 0 && live.live_status == 0">
                    <template #default="timeData">
                        <img class="time_img" src="/static/img/icon_live_count_down.svg" alt="" />
                        <span>距离直播开始：</span>
                        <span class="times">{{ timeData.days }}</span>
                        <span class="time_unit">天</span>
                        <span class="times">{{ timeData.hours }}</span>
                        <span class="time_unit">时</span>
                        <span class="times">{{ timeData.minutes }}</span>
                        <span class="time_unit">分</span>
                        <span class="times">{{ timeData.seconds }}</span>
                        <span class="time_unit">秒</span>
                    </template>
                </van-count-down>
                <div class="mudu-ready" style="background: none">
                    <div class="mudu-reset mudu-big-play-btn" v-if="live.live_status == 1 && ready && live.open_status == 1" @click="playCurrent">
                        <img src="/static/img/course/icon_course_play.svg" alt="" />
                    </div>
                </div>
                <div class="mudu-ready" v-if="live.live_status == 1 && ready && live.open_status == 2">
                    即将开启
                </div>
                <div class="mudu-ready" v-if="live.live_status > 1 && live.live_status < 6">
                    直播已结束
                </div>
                <div class="mudu-ready" v-if="live.live_status == 1 && !ready" id="mudu-ready">
                    <van-loading type="spinner" color="#fff" size="24px" vertical>加载中...</van-loading>
                </div>
            </div>
            <div class="ad" v-show="live.adverts_down && live.adverts_down.length > 0">
                <swiper ref="mySwiper" :options="swiperOption">
                    <swiper-slide class="ad_logo_slide" v-for="(item, index) in live.adverts_down" :key="index">
                        <img class="ad_logo" :src="item.logo" alt="" />
                    </swiper-slide>
                </swiper>
            </div>
            <div class="live-detail-home-content">
                <van-tabs :swipeable="true" :border="true" v-model="tab" @change="scrollEnd">
                    <div v-for="item in dlyTabContent" :key="item.id">
                        <van-tab :title="item.name" v-if="item.content_type === 1 && live.id != 899">
                            <div class="live-detail-home-common">
                                <div :class="'message ad_count_' + ad_count" ref="message">
                                    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" pulling-text="加载更多">
                                        <div class="message-section" v-for="(item, ci) in comment" :key="item.key">
                                            <div class="message-section-dateline">
                                                {{ item.key }}
                                            </div>
                                            <div class="message-section-box" v-for="(val, i) in item.comment" :key="val.id">
                                                <div @click="longTouch(i, ci)" class="message-section-photo">
                                                    <img :src="val.avatar" alt="" />
                                                </div>
                                                <div class="message-section-content">
                                                    <div @click="longTouch(i, ci)" class="message-section-content-author">
                                                        {{ val.nickname }}
                                                    </div>
                                                    <div v-if="val.showBtn" class="message-section-content-btns">
                                                        <span @click="subscribeUser(i, ci)">@ 对方</span>
                                                        <span @click="subscribeAndCite(i, ci)">@ 并引用</span>
                                                        <span @click="deleteMessage(i, ci)">删除</span>
                                                    </div>
                                                    <div
                                                        @click="longTouch(i, ci)"
                                                        :class="'message-section-content-detail ' + (val.manager === 1 ? 'manager' : '')"
                                                        v-html="val.message.replace(/\\x(\d{1,2})/g, '<img src=&quot;/static/emoji/$1.png&quot; />')"
                                                    ></div>
                                                    <div class="clear"></div>
                                                    <div
                                                        v-if="val.cite_content !== ''"
                                                        class="message-section-content-cite"
                                                        v-html="val.cite_content"
                                                    ></div>
                                                </div>
                                                <div class="clear"></div>
                                            </div>
                                        </div>
                                        <div class="message-end"></div>
                                    </van-pull-refresh>
                                </div>
                            </div>
                        </van-tab>
                        <van-tab :title="item.name" v-if="item.content_type === 3 && item.content && item.content !== null && item.content !== ''">
                            <div class="top-ad" style="margin-bottom: 30px;margin-left: 15px" v-if="content_items && content_items.length > 1">
                                <swiper ref="mySwiper2" :options="swiperOption2">
                                    <swiper-slide class="series_slide" v-for="(item, index) in content_items" :key="index">
                                        <div :class="'series_slide_box ' + (item.is_current == 1 ? 'current' : '')" @click="goItem(item)">
                                            <div class="series_slide_box-title">{{ item.title }}</div>
                                            <div class="series_slide_box-time">{{ '第' + hanz[index] + '场' }}</div>
                                            <div v-if="item.live_status === 0" class="series_slide_box-tags appoint">
                                                预告
                                            </div>
                                            <div v-else-if="item.live_status === 1" class="series_slide_box-tags current">
                                                <img src="https://bytx.care-gobroad.com/static/bytx/activity_list_live_icon.gif" alt="" />
                                                直播中
                                            </div>
                                            <div v-else-if="item.live_status === 6" class="series_slide_box-tags end">
                                                回放
                                            </div>
                                            <div v-else-if="item.live_status > 1" class="series_slide_box-tags end">
                                                已结束
                                            </div>
                                        </div>
                                    </swiper-slide>
                                </swiper>
                                <div class="clear"></div>
                            </div>
                            <div class="diy-content" v-html="item.content"></div>
                        </van-tab>
                        <van-tab :title="item.name" v-else-if="item.content_type === 2 && item.column_items && item.column_items.length > 0">
                            <div v-for="recommendItem in item.column_items" :key="recommendItem.id">
                                <Course v-if="recommendItem.origin_type === 1" :dataItem="recommendItem" />
                                <Case v-else-if="recommendItem.origin_type === 2" :dataItem="recommendItem" />
                                <Lives v-if="recommendItem.origin_type === 4" :dataItem="recommendItem" />
                                <Case v-else-if="recommendItem.origin_type === 6" :dataItem="recommendItem" />
                                <Guide v-else-if="recommendItem.origin_type === 9" :data-item="recommendItem" />

                                <div class="specials-list-section" v-else-if="recommendItem.origin_type === 13">
                                    <!-- 13专题 -->
                                    <van-row class="specials-list-section-box" @click="goTopicDetail(recommendItem)">
                                        <div class="specials-list-section-left">
                                            <van-image fit="cover" class="specials-list-section-left-img" :src="recommendItem.content.cover_img" width="100%" height="100%"/>
                                            <div class="specials-list-section-left-zl">
                                                专题
                                            </div>
                                        </div>
                                        <div class="specials-list-section-right">
                                            <div class="specials-list-section-right-title" v-html="recommendItem.content.title">
                                            </div>
                                        </div>
                                        <div class="clear"></div>
                                    </van-row>
                                </div>


                                <Medicine v-else-if="recommendItem.origin_type === 30" :dataItem="recommendItem" />

                                <div class="academic-list-section" v-else-if="recommendItem.origin_type === 14">
                                    <div class="academic-list-section-box" @click="goStudyMeeting(recommendItem.content)">
                                        <div class="academic-list-section-box-top">
                                            <img :src="recommendItem.content.cover_img" alt="" />
                                            <div class="academic-list-section-box-zl1" v-if="recommendItem.origin_type == 14">
                                                <img v-if="recommendItem.content.meeting_status== 0" src="static/v4/icon_list_tag_live_count_down.svg"/>
                                                <img v-else-if="recommendItem.content.meeting_status== 1" src="static/v4/icon_list_tag_academic_process.svg" />
                                                <img v-else-if="recommendItem.content.meeting_status== 2" src="static/v4/icon_list_tag_academic_end.svg"/>
                                            </div>
                                            <div class="academic-list-section-box-zl1" v-else-if="recommendItem.origin_type == 4">
                                                <img v-if="recommendItem.content.live_status== 0" src="static/v4/icon_list_tag_live_count_down.svg"/>
                                                <img v-else-if="recommendItem.content.live_status== 1" src="static/v4/icon_list_tag_academic_process.svg" />
                                                <img v-else-if="recommendItem.content.live_status== 2" src="static/v4/icon_list_tag_academic_end.svg"/>
                                            </div>
                                            <div class="academic-list-section-box-btn" v-if="recommendItem.origin_type == 14 && recommendItem.meeting_status != 2">
                                                <span v-if="recommendItem.content.isApply" class="meeting-list-box-img-btn-span1">已报名</span>
                                                <span v-else class="meeting-list-box-img-btn-span2" @click.stop="goStudyMeeting(dataItem.content)">报名参会</span>
                                            </div>
                                        </div>
                                        <div class="academic-list-section-box-title" v-html="recommendItem.title"></div>
                                        <div class="academic-list-section-box-time">{{ recommendItem.start_at }}</div>
                                    </div>
                                </div>
                            </div>
                        </van-tab>
                    </div>
                </van-tabs>
            </div>

            <img v-if="live.id != 727 && has_question" @click="questionsDialog = true" class="course-detail-question-button" src="/static/third/xf.svg" alt=""/>
            <!--            <img v-else-if="has_question" @click="questionsDialog = true" class="course-detail-question-button"-->
            <!--                 src="/static/two/btn_questionnaire.svg" alt="">-->
            <img @click="openShareData" class="course-detail-share-button" src="/static/img/btn_share.svg" alt="" />

            <div class="live-detail-home-footer" v-if="live.id != 899 && dlyTabContent && dlyTabContent[this.tab]">
                <div class="new-live-detail-home-footer-content-text" v-if="live && live.parent && live.parent.title" @click="goParent(live.parent)">
                    <van-image fit="cover" src="/static/img/course/icon_detail_tag_column.svg"></van-image>
                    <div>
                        {{ live.parent.title }}
                    </div>
                    <div><van-icon name="arrow" /></div>
                </div>
                <div class="live-detail-home-footer-box">
                    <div class="live-detail-home-footer-left">
                        <van-grid :column-num="1" :border="false">
                            <van-grid-item icon="/static/img/live/icon_live_meme.svg" @click="showActionMeme = !showActionMeme" />
                        </van-grid>
                    </div>
                    <div :class="'live-detail-home-footer-center ' + (comment_text != '' ? 'comment_in' : '')">
                        <van-field
                            round
                            left-icon="/static/img/course/icon_course_text.svg"
                            v-model="comment_text"
                            :disabled="live.id == 727"
                            placeholder="回复"
                        ></van-field>
                    </div>
                    <div :class="'live-detail-home-footer-right ' + (comment_text != '' ? 'comment_in' : '')">
                        <van-grid :column-num="1" :border="false" v-if="comment_text == ''">
                            <van-grid-item icon="/static/img/live/icon_live_more.svg" @click="showAction = !showAction" />
                        </van-grid>
                        <div class="live-detail-home-footer-right-btn" v-else>
                            <van-button type="danger" size="medium" @click="createComment('live')" color="#D3172E">
                                发送
                            </van-button>
                        </div>
                    </div>
                    <div class="clear"></div>
                    <div class="live-detail-home-footer-bottom" v-if="showAction">
                        <van-divider />
                        <van-grid :column-num="is_manager == 1 ? 3 : 2" :border="false">
                            <van-grid-item
                                v-if="live.downloads && live.downloads.length > 0"
                                icon="/static/img/course/icon_course_download.svg"
                                text="资料文库"
                                @click="showDownload = true"
                            />
                            <van-grid-item
                                @click="favorite()"
                                v-if="live.isFavorite"
                                icon="/static/img/course/icon_course_favorite_on_20.svg"
                                text="已收藏"
                            />
                            <van-grid-item @click="favorite()" v-else icon="/static/img/course/icon_course_favorite_off_20.svg" text="收藏" />
                            <van-grid-item text="发送图片" v-if="is_manager == 1">
                                <template slot="icon">
                                    <van-uploader :after-read="uploadCommentImg" accept="*">
                                        <img width="20" style="margin-bottom: 5px;margin-top: 3px" src="/static/two/upload_img.svg" alt="" />
                                    </van-uploader>
                                </template>
                            </van-grid-item>
                        </van-grid>
                        <van-divider />
                        <van-number-keyboard safe-area-inset-bottom />
                    </div>
                    <div class="live-detail-home-footer-bottom" v-if="showActionMeme">
                        <van-divider />
                        <van-grid :column-num="10" :border="false" v-if="$route.params.id == '578'">
                            <van-grid-item @click="choose_meme(5)" :icon="'/static/emoji/5.png'" />
                            <van-grid-item @click="choose_meme(9)" :icon="'/static/emoji/9.png'" />
                            <van-grid-item @click="choose_meme(15)" :icon="'/static/emoji/15.png'" />
                            <van-grid-item @click="choose_meme(17)" :icon="'/static/emoji/17.png'" />
                            <van-grid-item @click="choose_meme(25)" :icon="'/static/emoji/25.png'" />
                            <van-grid-item @click="choose_meme(44)" :icon="'/static/emoji/44.png'" />
                            <van-grid-item @click="choose_meme(61)" :icon="'/static/emoji/61.png'" />
                            <van-grid-item @click="choose_meme(62)" :icon="'/static/emoji/62.png'" />
                            <van-grid-item @click="choose_meme(71)" :icon="'/static/emoji/71.png'" />
                            <van-grid-item @click="choose_meme(72)" :icon="'/static/emoji/72.png'" />
                            <van-grid-item @click="choose_meme(76)" :icon="'/static/emoji/76.png'" />
                            <van-grid-item @click="choose_meme(77)" :icon="'/static/emoji/77.png'" />
                        </van-grid>
                        <van-grid :column-num="10" :border="false" v-else-if="$route.params.id == '727'">
                            <van-grid-item @click="choose_meme(62)" :icon="'/static/emoji/62.png'" />
                            <van-grid-item @click="choose_meme(71)" :icon="'/static/emoji/71.png'" />
                            <van-grid-item @click="choose_meme(72)" :icon="'/static/emoji/72.png'" />
                            <van-grid-item @click="choose_meme(76)" :icon="'/static/emoji/76.png'" />
                            <van-grid-item @click="choose_meme(77)" :icon="'/static/emoji/77.png'" />
                        </van-grid>
                        <van-grid :column-num="10" :border="false" v-else>
                            <van-grid-item @click="choose_meme(index)" :icon="'/static/emoji/' + index + '.png'" v-for="index in 77" :key="index" />
                        </van-grid>
                        <van-divider />
                        <van-number-keyboard safe-area-inset-bottom />
                    </div>
                </div>
            </div>

            <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
                <img class="share-top-img" src="/static/img/pic_course_share_text.svg" alt="" />
                <div v-if="showShareLoading == false">
                    <div class="share-img">
                        <img :src="htmlUrl" style="width: 100%" v-if="htmlUrl != ''" alt="" />
                    </div>
                    <div class="share-cancel-btn" @click="showShareDialog = false">
                        <img src="/static/img/course/icon_course_share_close.svg" alt="" />
                    </div>
                </div>
                <div v-else align="center">
                    <van-loading size="24px">正在生成分享图片</van-loading>
                </div>
            </van-dialog>

            <van-dialog class="content" v-model="needPassword" :show-confirm-button="false">
                <template slot="title">
                    <span v-if="!showPasswordUser">本场直播需要您输入观看密码</span>
                    <span v-else>获取密码</span>
                    <div style="float:right;position: absolute;right: 15px;top: 15px" @click="needPassword = false">
                        <img src="https://dr-yyh.com/static/img/course/icon_course_share_close_black.svg" alt="">
                    </div>
                </template>
                <div class="cancel_otp_code_box" v-if="!showPasswordUser">
                    <div class="otpInputs">
                        <input v-enterfocus ref="otpInputs" type="number" value="12" v-model="code" @keydown.delete="changeCode" />
                        <span class="code_list">{{ code1 }}</span>
                        <span class="code_list">{{ code2 }}</span>
                        <span class="code_list">{{ code3 }}</span>
                        <span class="code_list last_code_list">{{ code4 }}</span>
                    </div>
                    <p class="error_text" :class="{ show: error }">密码错误请重试</p>
                </div>
                <div v-else style="text-align: center">
                    <div class="scribe-desc" style="padding: 20px;text-align: center">请联系博医荟助手获取密码，电话18701312839，或扫码添加微信</div>
                    <img width="70%" src="https://gaobo-byh-h5.oss-cn-beijing.aliyuncs.com/meetings/xzs_qrcode.jpg" alt="" />
                </div>
                <div class="content-footer">
                    <van-button v-if="!showPasswordUser" style="width: 50%" type="danger" round @click="checkPassword(4)" color="#D3172E">
                        点击验证
                    </van-button>
                    <van-button v-else style="width: 50%" type="danger" round @click="showPasswordUser=false" color="#D3172E">
                        去输入密码
                    </van-button>

                    <div v-if="!showPasswordUser" style="color: #0fb7ad;font-size: 13px;margin-top: 20px" @click="showPasswordUser = true">联系博医荟小助手获取密码</div>
                </div>

            </van-dialog>

            <van-action-sheet v-model="showDownload" title="资料文库">
                <div class="download-cell">
                    <van-cell
                        title-class="download-cell__item"
                        v-for="item in live.downloads"
                        :key="item.link"
                        :title="item.name"
                        @click="download_item(item)"
                        :icon="item.type == 'pdf' ? '/static/img/course/icon_course_download_pdf.svg' : '/static/img/course/icon_course_download_pic.svg'" icon-size="20px">
                        <template slot="right-icon">
                            <van-icon name="/static/img/course/icon_course_download.svg" />
                        </template>
                    </van-cell>
                </div>
                <div class="van-action-sheet__footer" style="height: 30px">
                    <div class="van-action-sheet__gap"></div>
                </div>
            </van-action-sheet>

            <van-action-sheet v-model="questionsDialog" :title="questions.name">
                <div class="question-cell-group">
                    <div class="question-img" v-if="questions.pic != ''">
                        <img :src="questions.pic" width="100%" alt="" />
                    </div>

                    <div class="question-desc" v-if="questions.desc != ''" v-html="questions.desc"></div>

                    <div class="question-cell" v-for="(item, index) in questions.columns" :key="index">
                        <div v-if="item.type == 'phone'">
                            <div :class="'question-cell-title ' + item.must">{{ item.name }}</div>
                            <van-field v-model="questionData[index]" placeholder="请填写" border />
                        </div>

                        <div v-else-if="item.type == 'input'">
                            <div :class="'question-cell-title ' + item.must">{{ item.name }}</div>
                            <van-field v-model="questionData[index]" placeholder="请填写" border />
                        </div>

                        <div v-else-if="item.type == 'textarea'">
                            <div :class="'question-cell-title ' + item.must">{{ item.name }}</div>
                            <van-field rows="3" v-model="questionData[index]" placeholder="请填写" border />
                        </div>

                        <div v-else-if="item.type == 'questionAnswer'">
                            <div :class="'question-cell-title ' + item.must">{{ item.name }}</div>
                            <van-field rows="3" v-model="questionData[index]" placeholder="请填写" border />
                        </div>

                        <div v-else-if="item.type == 'question' && !item.multi_select">
                            <div :class="'question-cell-title ' + item.must">{{ item.name }}</div>
                            <van-radio-group v-model="questionData[index]" @change="radioChange">
                                <van-radio v-for="(val, key) in item.options" :key="key" :name="key" shape="round">
                                    {{ val }}
                                </van-radio>
                            </van-radio-group>
                        </div>

                        <div v-else-if="item.type == 'question' && item.multi_select">
                            <div :class="'question-cell-title ' + item.must">{{ item.name }}</div>
                            <van-checkbox-group v-model="questionData[index]">
                                <van-checkbox v-for="(val, key) in item.options" :key="key" :name="key" shape="round">
                                    {{ val }}
                                </van-checkbox>
                            </van-checkbox-group>
                        </div>
                    </div>

                    <van-button class="question-control" size="small" color="#D3172E" round block type="info" native-type="submit" @click="submitQuestion()">提交</van-button>
                </div>
                <div class="van-action-sheet__footer" style="height: 30px">
                    <div class="van-action-sheet__gap"></div>
                </div>
            </van-action-sheet>
        </div>

        <van-action-sheet class="scribe" v-model="showActionScribe" title="关注公众号">
            <img width="70%" :src="live.dialog_img" alt="" />
        </van-action-sheet>


        <van-dialog class="content" style="text-align: center" v-model="whiteListDialogVisible"  closeable :show-confirm-button="false">
            <template slot="title">
                <div style="position: absolute;top: 25px;text-align: center;width: 100%">提示</div>
                <div style="float:right;position: absolute;right: 15px;top: 15px" @click="whiteListDialogVisible = false">
                    <img src="https://dr-yyh.com/static/img/course/icon_course_share_close_black.svg" alt="">
                </div>
            </template>
            <div class="scribe-desc" style="padding: 20px;text-align: left">本场活动为定向观看，如您需观看可联系会务组或下方会务助手</div>
            <img width="70%" src="https://gaobo-byh-h5.oss-cn-beijing.aliyuncs.com/meetings/xzs_qrcode.jpg" alt="" />
            <div class="scribe-title" style="margin-bottom: 20px">请长按识别添加</div>
        </van-dialog>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import { formatTimeToStr } from '@/util/date'
import columnSkeleton from '@/skeleton/columnSkeleton'
import videojs from 'video.js'
import verify from '../../../mixins/verify'
import comment from '../../../mixins/comment'
import Recommend from './recommend.vue'
import { Academic, Case, Course, Guide, Lives, Medicine, Special } from '../../../components/contentSelection'

export default {
    name: 'live-detail-home',
    mixins: [verify, comment],
    components: {
        'column-skeleton': columnSkeleton,
        Recommend,
        Course,
        Case,
        Guide,
        Medicine,
        Lives,
        Academic,
        Special
    },
    data() {
        return {
            id: '',
            hanz: [
                '一',
                '二',
                '三',
                '四',
                '五',
                '六',
                '七',
                '八',
                '九',
                '十',
                '十一',
                '十二',
                '十三',
                '十四',
                '十五',
                '十六',
                '十七',
                '十八',
                '十九',
                '二十'
            ],
            swiperOption2: {
                loop: false,
                autoplay: false,
                spaceBetween: 16,
                slidesPerView: 2,
                centerInsufficientSlides: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },

            course: {},
            downloads: [],
            related: [],
            value: '',
            active: '',
            live: {},
            textMessage: '',
            player: '',
            viewNum: 0,
            tab: 0,
            loading: true,
            ready: true,
            video_url: '',
            share_data: {},
            showShareDialog: false,
            showShareLoading: false,
            htmlUrl: '',
            isShow: false,
            status: '',
            time: 0,
            user: {},
            showDownload: false,
            showAction: false,
            checkLogin: false,
            myPlayer: '',
            swiperOption: {
                loop: false,
                autoplay: true,
                slidesPerView: 3,
                slidesPerGroup: 3,
                centerInsufficientSlides: true
            },
            interval: '',
            current: 0,
            busy: false,
            autoplay: false,
            live_manager_avatar: [],
            video_id: '',
            open_status: 2,
            increase: 1,
            refreshing: false,
            is_manager: 0,
            last_comment_id: 0,
            has_question: false,
            questions: {
                columns: []
            },
            questionsDialog: false,
            questionData: [],
            content_items: [],
            ad_count: 0,
            fetch_busy: false,
            item_id: 0,
            dlyTabContent: [],

            showActionScribe:false,
            whiteListDialogVisible:false,
        }
    },
    filters: {
        formatDate: function(time) {
            return formatTimeToStr(time * 1000, 'MM月dd日 hh:mm')
        }
    },
    methods: {
        goParent(row) {
            this.$router.push({
                name: 'live-column',
                params: { id: row.id }
            })
        },
        playCurrent() {
            this.ready = false
            this.autoplay = true
        },
        onRefresh() {
            this.refreshing = false
        },
        fetch(scene) {
            if (scene === 'live') {
                sessionStorage.setItem('live_id', this.id)

                if (this.fetch_busy) {
                    return
                }
                let params = {
                    increase: this.increase
                }
                if (this.item_id != 0) {
                    params.item_id = this.item_id
                }
                this.fetch_busy = true
                Interface.getData('get', Interface.live.detail + '/' + this.id, params).then(res => {
                    this.live = res.data.live
                    let has_intro = false

                    if (res.data.live.columns && res.data.live.columns.length > 0) {
                        res.data.live.columns.forEach((val, i) => {
                            let content = val.content
                            if (val.name == '介绍') {
                                has_intro = true
                                if (content == '' && this.live.content != '') {
                                    content = this.live.content
                                }
                                res.data.live.columns[i].content =
                                    '<div class="live-detail-home-header">\n' +
                                    '                        <div class="header-title"> ' +
                                    this.live.title +
                                    ' </div>\n' +
                                    '                        <div class="header-author"> ' +
                                    this.live.start_at_format +
                                    ' </div>\n' +
                                    '                    </div>' +
                                    content
                            }
                        })

                        this.dlyTabContent = res.data.live.columns
                    } else {
                        this.dlyTabContent = [
                            {
                                content_type: 1,
                                name: '互动'
                            }
                        ]
                    }

                    if (this.live.content != '' && !has_intro) {
                        this.dlyTabContent.unshift({
                            content_type: 3,
                            name: '介绍',
                            content:
                                '<div class="live-detail-home-header">\n' +
                                '                        <div class="header-title"> ' +
                                this.live.title +
                                ' </div>\n' +
                                '                        <div class="header-author"> ' +
                                this.live.start_at_format +
                                ' </div>\n' +
                                '                    </div>' +
                                this.live.content
                        })
                    }

                    if (this.dlyTabContent.length <= 3 && this.live.extra_content && this.live.extra_content.length > 0) {
                        this.live.extra_content.forEach(val => {
                            this.dlyTabContent.push({
                                content_type: 3,
                                name: val.name,
                                content: val.content
                            })
                        })
                    }

                    if (res.data.content_items) {
                        this.content_items = res.data.content_items

                        let bool = false
                        for (var i = 0; i < this.content_items.length; i++) {
                            if (this.content_items[i].live_status == 1) {
                                if (typeof this.$route.query.item_id == 'undefined' && this.content_items.length > 1) {
                                    // this.goItem(this.content_items[i])
                                    // return
                                }
                                bool = true
                                break
                            }
                        }
                        for (var i = 0; i < this.content_items.length; i++) {
                            if (this.content_items[i].live_status == 0) {
                                if (typeof this.$route.query.item_id == 'undefined' && this.content_items.length > 1) {
                                    // this.goItem(this.content_items[i])
                                    // return
                                }
                                bool = true
                                break
                            }
                        }
                        if (!bool) {
                        }
                    } else {
                        this.content_items = []
                    }

                    if (this.live.live_status < 6) {
                        let dom = document.getElementById('mudu')
                        dom.innerHTML =
                            '<div id="' +
                            this.video_id +
                            '" class="mudu"></div><div class="live-detail-view_count"><img src="/static/img/icon_live_watch.svg" alt="">' +
                            this.live.view_count +
                            '人观看</div>'
                    } else {
                        this.initVideo()
                    }

                    this.ad_count = 0
                    if (this.live.adverts_up && this.live.adverts_up.length > 0) {
                        this.ad_count += 1
                    }
                    if (this.live.adverts_down && this.live.adverts_down.length > 0) {
                        this.ad_count += 1
                    }

                    setTimeout(() => {
                        this.initMudu()
                        this.loading = false
                    }, 300)

                    if (this.live.live_manager != null && this.live.live_manager.length > 0) {
                        this.live.live_manager.forEach(val => {
                            this.live_manager_avatar.push(val.avatar)
                            if (this.user.id === val.id) {
                                this.is_manager = 1
                            }
                        })
                    } else {
                        this.live_manager_avatar = []
                    }
                    document.title = this.live.title
                    if (this.live) {
                        Interface.getShareInfo(
                            this,
                            this.live.title,
                            this.live.cover_img,
                            '点击观看直播',
                            4,
                            this.live.id,
                            Interface.host + '/#/live-detail/' + this.live.id
                        )
                        let source_type = Interface.getUrl(window.location.href)
                        if (source_type) {
                            Interface.mFootPrint(this.live.id, 4,0, 0, source_type, this.live.title)
                        } else {
                            Interface.mFootPrint(this.live.id, 4,0, 0, 0, this.live.title)
                        }
                    }

                    this.time = this.live.limit_time
                    if (this.live.show_dialog === 1 && this.live.dialog_img != '' && !this.live.isShowDialog) {
                        this.showActionScribe = true
                        Interface.getData("get",Interface.live.showDialog+this.live.id)
                    }

                    if (this.live.id == 208) {
                        this.live.live_status = 6
                    }

                    if (this.live.downloads != null && this.live.downloads.length > 0) {
                        this.live.downloads.forEach(item => {
                            if (item.link) {
                                item.type = item.link.substr(item.link.length - 3, 3)
                            }
                        })
                    } else {
                        this.live.downloads = []
                    }

                    this.fetch('subscribe')
                    this.intervalCheck()
                    this.getComment()
                    this.fetch('live_record')
                    this.increase = 2
                    this.fetch_busy = false
                })
            } else if (scene === 'live_record') {
                let params = {
                    content_id: this.id,
                    type: 4,
                    randStr: this.video_id
                }
                Interface.getData('get', Interface.live.record, params)
            } else if (scene === 'subscribe') {
                Interface.getData('get', Interface.live.subscribeItem + this.id).then(res => {})
            }
        },
        getViewCount() {
            Interface.getData('get', Interface.live.view_count + '/' + this.id).then(res => {
                if (res && res.code == 0) {
                    this.open_status = res.data.open_status
                    this.live.view_count = res.data.view_count

                    let countEl = document.getElementsByClassName('live-detail-view_count')
                    if (countEl && countEl.length > 0) {
                        countEl[0].innerHTML = res.data.view_count + '人观看'
                    }

                    if (res.data.open_status == 1 && this.live.live_status == 0 && res.data.live_status == 1) {
                        setTimeout(() => {
                            this.fetch('live_record')
                            if (Mudu) {
                                Mudu.Destroy()
                            }
                            if (this.interval != '') {
                                clearInterval(this.interval)
                            }
                            this.video_id = 'J_prismPlayer' + this.randomNum(1111, 9999)
                            this.fetch('live')
                        }, 3000)
                    } else if (res.data.open_status == 1 && this.live.live_status == 1 && this.live.open_status == 2) {
                        setTimeout(() => {
                            this.fetch('live_record')
                            if (Mudu) {
                                Mudu.Destroy()
                            }
                            if (this.interval != '') {
                                clearInterval(this.interval)
                            }
                            this.video_id = 'J_prismPlayer' + this.randomNum(1111, 9999)
                            this.fetch('live')
                        }, 3000)
                    } else if (res.data.open_status == 2 && this.live.live_status == 1 && this.live.open_status == 1) {
                        setTimeout(() => {
                            this.fetch('live_record')
                            if (Mudu) {
                                Mudu.Destroy()
                            }
                            if (this.interval != '') {
                                clearInterval(this.interval)
                            }
                            this.video_id = 'J_prismPlayer' + this.randomNum(1111, 9999)
                            this.fetch('live')
                        }, 3000)
                    } else if (this.live.live_status < 2 && res.data.live_status == 2) {
                        setTimeout(() => {
                            this.fetch('live_record')
                            if (Mudu) {
                                Mudu.Destroy()
                            }
                            if (this.interval != '') {
                                clearInterval(this.interval)
                            }
                            this.video_id = 'J_prismPlayer' + this.randomNum(1111, 9999)
                            this.fetch('live')
                        }, 3000)
                    }
                }
            })
        },
        initMudu() {
            let _this = this
            window.Mudu.Init(
                // 频道id
                _this.live.webinar_id,
                // 初始化完成的回调函数，无参数
                function() {
                    let name = _this.user.name !== '' ? _this.user.name : _this.user.nick_name
                    window.Mudu.Room.User.Assign(name, _this.user.avatar, _this.user.id, () => {})

                    try {
                        Mudu.Room.Signup.GetUsingSignup(function(dataStr) {
                            // data 数据结果如下表所示
                            var data = JSON.parse(dataStr)
                            if (data.page_before.length > 0) {
                                _this.has_question = true
                                _this.questions = data.page_before[0]
                            } else if (data.page_in.length > 0) {
                                _this.has_question = true
                                _this.questions = data.page_in[0]
                            }
                            console.log(_this.questions)
                        })
                    } catch ($err) {}

                    //建立websocket
                    window.Mudu.MsgBus.On('Comment.New', function() {
                        setTimeout(() => {
                            _this.getComment()
                        }, 500)
                    })

                    Mudu.MsgBus.On('Room.StreamEvent', function(data) {
                        setTimeout(() => {
                            _this.fetch('live_record')
                            if (Mudu) {
                                Mudu.Destroy()
                            }
                            if (_this.interval != '') {
                                clearInterval(_this.interval)
                            }
                            _this.video_id = 'J_prismPlayer' + _this.randomNum(1111, 9999)
                            _this.fetch('live')
                        }, 3000)
                    })

                    if (_this.live.live_status === 1 && _this.live.open_status === 1) {
                        new Mudu.Player({
                            containerId: _this.video_id,
                            isLive: !!Mudu.Room.GetLiveStatus(),
                            src: Mudu.Room.GetPlayAddrList(),
                            image: _this.live.cover_img,
                            autoplay: _this.autoplay,
                            controls: true,
                            repeat: false,
                            width: '100%',
                            height: '100%',
                            x5Layer: false,
                            x5Inline: false
                        })

                        //判断是否注册
                        Mudu.MsgBus.On('Player.Play', function(player) {
                            if (_this.checkLiveAuth(_this) !== 'ok'){
                                player.stop()
                            }
                        })

                        //更改loading状态
                        Mudu.MsgBus.On('Player.Ready', function(player) {
                            _this.ready = true
                        })
                        _this.ready = true

                        Mudu.MsgBus.On(
                            // 事件名，值为Room.StreamEvent
                            'Room.StreamEvent',

                            // 事件处理函数，参数类型为object
                            function(data) {
                                var msg = data.event == 1 ? '开始直播' : '停止直播'
                                setTimeout(() => {
                                    if (data.event != 1) {
                                        _this.fetch('live_record')
                                        if (Mudu) {
                                            Mudu.Destroy()
                                        }
                                        if (_this.interval != '') {
                                            clearInterval(_this.interval)
                                        }
                                        _this.video_id = 'J_prismPlayer' + _this.randomNum(1111, 9999)
                                        _this.fetch('live')
                                    }
                                }, 3000)
                            }
                        )
                    }
                }
            )
        },

        checkLiveAuth(_this){

            if(_this.needGoLogin(_this,_this.live.hasIInWhiteList) !== 'ok'){
                return 'notLogin'
            }

            if(_this.live.live_status >= 1){
                _this.checkLogin = true
                _this.is_sign_in = true
                if(_this.live.auth_type == 2 && !_this.live.isPasswordAuth){
                    _this.needPassword = true
                    return 'notPasswordAuth'
                }else if(_this.live.auth_type == 3 && !_this.live.hasIInWhiteList){
                    _this.whiteListDialogVisible = true
                    return 'notInWhiteList'
                }
            }

            return 'ok'
        },

        initVideo() {
            console.log('initVideo')
            let _this = this
            if (this.live.live_status < 2) {
                window.Mudu.Init(
                    // 频道id
                    _this.live.webinar_id,
                    // 初始化完成的回调函数，无参数
                    function() {}
                )
            } else if (this.live.live_status == 6) {
                if (this.live.id == 208) {
                    let videoUrl =
                        'https://gaobo-origin-videos.oss-cn-beijing.aliyuncs.com/20211106-%E7%AC%AC%E5%8D%81%E4%B8%80%E5%B1%8A%E8%A1%80%E6%B6%B2%E8%82%BF%E7%98%A4%E9%AB%98%E5%B3%B0%E8%AE%BA%E5%9D%9B20211106075426/%E5%8E%9F%E8%A7%86%E9%A2%91.mp4'
                    const myPlayerOptions = {
                        bigPlayButton: true,
                        textTrackDisplay: true,
                        posterImage: true,
                        errorDisplay: true,
                        controlBar: true,
                        autoplay: false,
                        controls: true
                    }
                    this.course_img_visible = false
                    setTimeout(() => {
                        this.myPlayer = videojs(this.video_id, myPlayerOptions, function onPlayerReady() {
                            this.on('play', function() {
                                if (_this.checkLiveAuth(_this) !== 'ok'){
                                    this.pause()
                                }
                            })
                        })
                        this.myPlayer.src(videoUrl)
                        this.myPlayer.poster(_this.live.cover_img)
                        this.myPlayer.load(videoUrl)
                        this.loading = false
                        setTimeout(() => {
                            this.ready = true
                        }, 500)
                    }, 500)
                }

                let _this = this
                Interface.getData('get', Interface.video_info + '/' + _this.live.video_id).then(resp => {
                    if (resp.code == 500){
                        return;
                    }

                    let videoUrl
                    resp.data.PlayInfoList.PlayInfo.forEach(val => {
                        if (val.Format == 'mp4') {
                            videoUrl = val.PlayURL
                        }
                    })
                    const myPlayerOptions = {
                        bigPlayButton: true,
                        textTrackDisplay: true,
                        posterImage: true,
                        errorDisplay: true,
                        controlBar: true,
                        autoplay: false,
                        controls: true
                    }
                    this.course_img_visible = false
                    setTimeout(() => {
                        this.myPlayer = videojs(this.video_id, myPlayerOptions, function onPlayerReady() {
                            this.on('play', function() {
                                if (_this.checkLiveAuth(_this) !== 'ok'){
                                    this.pause()
                                }
                            })
                        })
                        this.myPlayer.src(videoUrl)
                        this.myPlayer.poster(_this.live.cover_img)
                        this.myPlayer.load(videoUrl)
                        this.loading = false
                        setTimeout(() => {
                            this.ready = true
                        }, 500)
                    }, 500)
                })
            } else if (this.live.live_status == 7) {
                let _this = this
                let videoUrl = this.live.oss_path
                const myPlayerOptions = {
                    bigPlayButton: true,
                    textTrackDisplay: true,
                    posterImage: true,
                    errorDisplay: true,
                    controlBar: true,
                    autoplay: false,
                    controls: true
                }
                this.course_img_visible = false
                setTimeout(() => {
                    this.myPlayer = videojs(this.video_id, myPlayerOptions, function onPlayerReady() {
                        this.on('play', function() {

                            if (_this.checkLiveAuth(_this) !== 'ok'){
                                this.pause()
                            }

                        })
                    })
                    this.myPlayer.src(videoUrl)
                    this.myPlayer.poster(_this.live.cover_img)
                    this.myPlayer.load(videoUrl)
                    this.loading = false
                    setTimeout(() => {
                        this.ready = true
                    }, 500)
                }, 500)
            } else {
                this.loading = false
                this.ready = true
            }
        },
        scrollEnd() {
            if (this.dlyTabContent[this.tab].content_type == 1) {
                setTimeout(() => {
                    let scrollDom = this.$refs.message
                    try {
                      scrollDom.scroll({ top: 5000000, left: 0, behavior: 'smooth' })
                    }catch (e) {
                      console.log(e)
                    }
                }, 500)
            }
        },
        randomNum(minNum, maxNum) {
            return new Date().getTime()
        },
        openShareData() {
            let params = {
                content_id: this.id,
                type: 4
            }
            this.showShareLoading = true
            this.showShareDialog = true
            Interface.getData('get', Interface.share, params).then(res => {
                this.htmlUrl = res.data.post_img_url
                this.showShareLoading = false
            })
            Interface.mFootPrint(this.live.id, 4,0, 0, 2, this.live.title)
        },
        favorite() {
            Interface.getData('get', Interface.live.favorite + this.id).then(res => {
                if (res.code == 0) {
                    this.live.isFavorite = !this.live.isFavorite
                }
            })
        },
        download_item(item) {
            let user = localStorage.getItem('user')
            user = JSON.parse(user)
            if (user.is_complete !== 1) {
                this.$dialog
                    .confirm({
                        title: '需要登录',
                        message: '为了方便学习课程,需要您登录认证',
                        confirmButtonText: '去认证'
                    })
                    .then(() => {
                        sessionStorage.setItem('back-url', this.$route.path)
                        this.$router.push({ name: 'login' })
                    })
                    .catch(() => {
                        // on cancel
                    })
                return
            }
            window.location.href = item.link
        },
        finish() {
            if (this.live.live_status == 0) {
                this.fetch('live')
            }
        },
        intervalCheck() {
            if (this.interval != '') {
                clearInterval(this.interval)
            }
            try {
                this.interval = setInterval(() => {
                    this.getViewCount()
                    this.fetch('live_record')
                }, 6000)
            } catch (e) {
                console.log(e)
            }
        },
        in_array(search, array) {
            if (array != null && array.length > 0) {
                for (let i in array) {
                    if (array[i] == search) {
                        return true
                    }
                }
            }
            return false
        },
        radioChange() {
            this.$forceUpdate()
        },
        submitQuestion() {
            let _this = this
            let columns = []
            this.questions.columns.forEach((val, i) => {
                if (val.type === 'input' || val.type === 'textarea' || val.type === 'questionAnswer' || val.type === 'phone') {
                    columns.push({
                        type: val.type,
                        name: val.name,
                        text: this.questionData[i]
                    })
                } else if (val.type === 'question') {
                    columns.push({
                        type: val.type,
                        name: val.name,
                        text: '',
                        selects: typeof this.questionData[i] == 'string' ? [this.questionData[i]] : this.questionData[i]
                    })
                }
            })

            Mudu.Room.Signup.SubmitSingup(
                {
                    code: '',
                    signupId: this.questions.question_id, // 必须 string 问卷id
                    columns: columns
                },
                function(response) {
                    // response 中对应的错误码见页面底部
                    response = JSON.parse(response)
                    if (response.errcode == '1000') {
                        _this.$toast.success('提交成功')
                        _this.questionsDialog = false
                    } else {
                        if (response.msg == '参数错误') {
                            response.msg = '有必填项未填写'
                        }
                        _this.$toast.fail(response.msg)
                    }
                }
            )
        },
        goItem(item) {
            this.$router.push({ name: 'live-detail-home', params: { id: this.id }, query: { item_id: item.id } })
            localStorage.removeItem('first_mount')
            window.location.reload()
        },
        goTopicDetail(item){
            this.$router.push({ name: 'topic-detail', params: { id: item.content.id } })
        },
        goStudyMeeting(item){
            // return
            if (item.origin_type == 4) {
                // 直播
                Interface.goLiveDetail(this,item)
            } else if (item.origin_type == 31 || item.origin_type == 14) {
                // 会议
                Interface.goMeeting(this,item)
            } else if (item.origin_type == 13) {
                this.$router.push({name: 'topic-detail', params: { id: item.id }})
            }
        }
    },
    created() {
        let first_mount = localStorage.getItem('first_mount')
        if (first_mount == '1') {
            localStorage.removeItem('first_mount')
            window.location.reload()
        } else {
            localStorage.setItem('first_mount', 1)
        }
        this.id = this.$route.params.id
        this.item_id = this.$route.query.item_id
        let _user = localStorage.getItem('user')
        this.user = JSON.parse(_user)
        this.video_id = 'J_prismPlayer' + this.randomNum(1111, 9999)
        this.fetch('live')
        // Interface.footPrint(4, this.id)
    },
    beforeDestroy() {
        this.fetch('live_record')
        if (this.myPlayer) {
            this.myPlayer.dispose()
        }
        if (Mudu) {
            Mudu.Destroy()
        }
        if (this.interval != '') {
            clearInterval(this.interval)
        }
    }
}
</script>

<style lang="scss">
@import './index.scss';

.academic-list-section{
    width: 335px;
    background: #fff;
    padding: 0;
    margin: 0 auto;
    padding-bottom: 16px;
    margin-top: 10px;
    border-radius: 8px;
    &-box{
        width: 335x;
        border-radius: 8px;
        &-top{
            position: relative;
            width: 335px;
            border-radius: 8px;
            img{
                width: 335px;
                border-radius: 8px;
            }
        }
        &-title{
            padding: 0 14px;
        }
        &-time{
            padding: 0 14px;
        }
        &-zl1{
            position: absolute;
            left: 0;
            top: 0;
            img{
                width: 40px;
                height: 18px;
                border-radius: 6px 2px 6px 2px;
            }
        }
        /deep/ .light {
            color: #D81D20;
        }
        &-btn{
            width: 100%;
            position: absolute;
            right: 12px;
            bottom: 12px;
            text-align: right;
            span{
                display: inline-block;
                width: 82px;
                height: 30px;
                line-height: 30px;
                background: #FFFFFF;
                box-shadow: 0px 2px 6px 0px rgba(239,44,58,0.1);
                border-radius: 17px;
                font-size: 13px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #D81D20;
                text-align: center;
            }
        }
        &-title{
            margin-top: 10px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #222222;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
        &-time{
            margin-top: 6px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9D9D9D;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/live/detail_home/index.vue